module.exports = __webpack_public_path__ + "static/media/i-provide-service.01e5f6ec.svg";